import gitHub from './octoCat.js';
import AlexanderIvankovLogo from './AlexanderIvankovLogo.js';

export default {
  gitHub,
  AlexanderIvankovLogo,
};
